import styled from "@emotion/styled";

export const ExportWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${p => p.theme.space[5]}px;
  align-items: center;
`;

export const ExportTextTitle = styled.p`
  font-size: 16px;
  font-weight: ${p => p.theme.fontWeight.medium};

  color: ${({ theme }) => theme.colors.secondary.minor};
  line-height: normal;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
  }
`;

export const ExportList = styled.ul`
  display: flex;
`;

export const ExportItem = styled.li`
  :not(:last-child) {
    margin-right: ${p => p.theme.space[5]}px;
  }

  font-size: ${p => p.theme.fontSizes.s};
  font-weight: ${p => p.theme.fontWeight.medium};
  line-height: 1.42;

  color: ${({ theme }) => theme.colors.secondary.minor};
  border-bottom: 1px dashed ${({ theme }) => theme.colors.secondary.minor};
  cursor: pointer;
  list-style: none;
  transition:
    color 0.3s ease,
    border-color 0.3s ease;

  :hover {
    color: ${({ theme }) => theme.colors.black};
    border-color: ${({ theme }) => theme.colors.black};
  }

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 16px;
    line-height: normal;
  }
`;
